import React from 'react'

const DesignSystem = () => {
  return (
    <div className="isave-design">
      <h4>Design System</h4>
      <p>
        All components and color used in the design system of the app was designed to promote consistency all through the different screens of Isave app.
      </p>
    </div>
  )
}

export default DesignSystem